import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { changeWbMarket } from '../../../actions/wb';
import { NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Select } from '../../../components/Basic/Inputs';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD, MAP_WB_SKLAD_NAME, TYPE_BUTTONS, WB_1, WB_1_EKB, WB_2, WB_2_EKB, WB_3, WB_3_EKB, WB_4, WB_4_EKB, WB_5, WB_5_EKB, WB_6, WB_6_EKB, WB_7, WB_7_EKB } from '../../../constans';
import styles from './styles.module.scss';

const calcSevenDayAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 3 * 24 * 3600000);

  return start;
};

const InitDate = () => {
  const start = new Date();
  start.setTime(start.getTime() + 24 * 3600000);

  return start;
};


const navTabs = [
  { name: 'Новые заказы', path: '/orders/wb' },
  { name: 'Поставки', path: '/orders/wb/supplies' }
]


function WbPage({ ...props }) {
  const [skladName, setSkladName] = useState('Не выбран');
  const [status, setStatus] = useState({ status: 'new', title: 'Новые' });
  const [period, setPeriod] = useState({ start: calcSevenDayAgo(), end: new Date() });
  const [date, setDate] = useState(InitDate());
  const [customerType, setCustomerType] = useState('ФизЛицо');
  const navigate = useNavigate();

  const location = useLocation()
  const [tab, setTab] = useState(navTabs.find(t => t.path === location.pathname)?.name);

  const onChangeTab = (newNavTabName) => {
    const newTab = navTabs.find(t => t.name === newNavTabName)
    if (newNavTabName === 'Поставки') {
      dispatch(changeWbMarket('WB-1'));
      setSkladName('Не выбран')
    }
    setTab(newTab.name);
    navigate(newTab.path);
  };

  const shop = useSelector((store) => store.wb.market);
  const dispatch = useDispatch();

  return (
    <Content>
      <H1>Отправления со склада</H1>
      <Row style={{ alignItems: 'start' }}>
        <WhiteBlock style={{ marginRight: '15px' }}>
          {tab === 'Новые заказы' && <Row style={{ marginBottom: '20px' }} >
            <Select
              label="Выбрать город"
              select={skladName}
              big={true}
              width="200px"
              disabled={tab !== 'Новые заказы'}
              onSelect={(m) => {
                // setPostings([]);
                setSkladName(m);
                // dispatch(changeWbMarket('Все'));

              }}
              list={['Москва', 'Екатеринбург', 'Не выбран']}
            />
            <Select
              style={{ marginLeft: '20px' }}
              label="Покупатель"
              select={customerType}
              width="130px"
              onSelect={(m) => {
                setCustomerType(m);
              }}
              list={['ФизЛицо', 'ЮрЛицо']}
            />
          </Row>
          }

          <Row>
            <div>
              <Row style={{ height: '80px' }}>
                <Select
                  label="Магазин"
                  select={skladName === 'Не выбран' ? shop : 'Все'}
                  // select={shop}
                  width="120px"
                  style={{ marginBottom: '10px', marginRight: '35px' }}
                  list={[WB_1, WB_2, WB_3, WB_4, WB_5, WB_6, WB_7, WB_1_EKB, WB_2_EKB, WB_3_EKB, WB_4_EKB, WB_5_EKB, WB_6_EKB, WB_7_EKB]}
                  disabled={skladName !== 'Не выбран'}
                  onSelect={(v) => dispatch(changeWbMarket(v))}
                />

                <Row className={styles.navigate_table}>
                  <NavTabs
                    // activ  eTab={navTabs.find(t => t.path === )}
                    getTabName={true}
                    open_tab={navTabs?.find(t => t.path === location.pathname)?.name}
                    tabs={navTabs.map(t => t.name)}
                    style_tab={styles.style_tab}
                    onChange={onChangeTab}
                  />
                </Row>
              </Row>

            </div>
          </Row>
        </WhiteBlock>
        {
          false &&
          // (tab === 1) &&
          <WhiteBlock >
            <H2 style={{ marginBottom: '20px' }}>{`Создать поставки ${MAP_SKLAD[MAP_WB_SKLAD_NAME[shop]]}`} </H2>
            <Row>
              <DateInput
                value={date}
                onChange={(v) => setDate(new Date(v))}
                classNameCalendar={styles.data}
                width={'230px'}
              />
              <Button type={TYPE_BUTTONS.BLUE}
                // onClick={shipOrders}
                style={{ marginLeft: '15px' }}
              >
                Создать
              </Button>
            </Row>
          </WhiteBlock>
        }

      </Row>

      <Outlet context={{ shop, skladName, customerType }} />

    </Content>
  );
}

export default WbPage;
